import { Record, List } from 'immutable'

const Filter = Record({
  id: 'none',
  name: 'No docs',
  subtitle: null,
  help: '',
  icon: null,
  emptyIcon: null,
  iconColor: null,
  selectNoteIds: () => List(),
})

export default Filter
